import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import API from '../../config/config';


const ProductVideoContent = (props: any) => {
  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined
    });
    useEffect(() => {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
      };

      window.addEventListener('resize', handleResize);
      handleResize()
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return dimension
  }

  return (
    <React.Fragment>
      <div className={windowSize.width >= 580 ? 'show' : 'hide'}>
        <div className="productVideoContent-background">
          <div className="container-fluid">
            <div className="container">
              <Row>
                <Col className="productVideoContent-flex">
                  <video className="productVideo-video" autoPlay loop muted>
                    <source
                      src={API.baseUrl + props.data.ProductInfo.image.url}
                      type="video/mp4"
                    />
                    {/* <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track> */}
                  </video>
                </Col>
                <Col>
                  <div className="productVideoContent-flex">
                    <div>
                      <h2 className="productVideoContent-h2">{props.data.ProductInfo.title}</h2>
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: props.data.ProductInfo.description }}>

                    </div>
                    <div style={{ marginTop: '20px' }}>
                      <a className="productVideoContent-Button" href={API.baseUrl + props.data.url}>
                        {props.data.ShowNowButton.text}
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div className={windowSize.width < 579 ? 'show' : 'hide'}>
        <div className="productVideoContent-background">
          <div className="container-fluid">
            <div className="container">
              <Row xs={1} md={1}>
                <Col className="productVideoContent-flex" xs={{ order: 2 }} md={{ order: 2 }}>
                  <video className="productVideo-video" autoPlay loop muted>
                    <source
                      src={API.baseUrl + props.data.ProductInfo.image.url}
                      type="video/mp4"
                    />
                    {/* <track src="captions_en.vtt" kind="captions" srcLang="en" label="english_captions"></track> */}
                  </video>
                </Col>
                <Col xs={{ order: 1 }} md={{ order: 1 }}>
                  <div className="productVideoContent-flex">
                    <div>
                      <h2 className="productVideoContent-h2">{props.data.ProductInfo.title}</h2>
                    </div>
                  </div>
                </Col>
                <Col xs={{ order: 3 }} md={{ order: 3 }}>
                  <div className="productVideoContent-flex">
                    <div dangerouslySetInnerHTML={{ __html: props.data.ProductInfo.description }}></div>
                    <div style={{ marginTop: '20px' }}>
                      <a className="productVideoContent-Button" aria-label={props.data.url} href={API.baseUrl + props.data.url}>
                        {props.data.ShowNowButton.text}
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductVideoContent;
